/* ============================================================
   Volopharm Blog Enhancements – v2
   ============================================================
   Änderungen gegenüber v1:
   - TOC wird NICHT mehr in .article__wrapper als Sidebar gerendert
     (das kollidierte mit dem Hero-Bild und der Content-Width).
   - Stattdessen: Wir wrappen den existierenden Body-Container
     (<div class="v-stack gap-10 sm:gap-16" data-vp-article-body>)
     in ein neues 2-Spalten-Grid mit TOC links und Body rechts.
   - Hero-Bild bleibt unangetastet voll breit oben (Prestige-default).
   ============================================================ */

(function () {
  'use strict';

  /* ------------------------------------------------------------
     1. FAQ-AUTO-AKKORDEON
     ------------------------------------------------------------ */

  function enhanceFaqBlocks() {
    var faqBlocks = document.querySelectorAll('.vp-faq:not(.vp-faq--enhanced)');
    if (!faqBlocks.length) return;

    var chevronSvg =
      '<svg class="vp-faq-item__icon" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2" aria-hidden="true">' +
      '<polyline points="6 9 12 15 18 9"></polyline></svg>';

    faqBlocks.forEach(function (block) {
      var headings = Array.prototype.slice.call(block.children).filter(function (el) {
        return el.tagName === 'H3';
      });

      if (!headings.length) return;

      var items = headings.map(function (heading) {
        var bodyNodes = [];
        var sibling = heading.nextElementSibling;
        while (sibling && sibling.tagName !== 'H3') {
          bodyNodes.push(sibling);
          sibling = sibling.nextElementSibling;
        }
        return { heading: heading, bodyNodes: bodyNodes };
      });

      var fragment = document.createDocumentFragment();
      items.forEach(function (item) {
        var details = document.createElement('details');
        details.className = 'vp-faq-item';

        var summary = document.createElement('summary');
        var span = document.createElement('span');
        span.textContent = item.heading.textContent;
        summary.appendChild(span);
        summary.insertAdjacentHTML('beforeend', chevronSvg);

        var body = document.createElement('div');
        body.className = 'vp-faq-item__body';
        item.bodyNodes.forEach(function (node) {
          body.appendChild(node.cloneNode(true));
        });

        details.appendChild(summary);
        details.appendChild(body);
        fragment.appendChild(details);
      });

      while (block.firstChild) block.removeChild(block.firstChild);
      block.appendChild(fragment);
      block.classList.add('vp-faq--enhanced');
    });
  }

  /* ------------------------------------------------------------
     2. INHALTSVERZEICHNIS (TOC) GENERIEREN + Body in Grid wrappen
     ------------------------------------------------------------
     Das ist die zentrale Layout-Änderung:

     VORHER:
       .article__wrapper
         > .v-stack[data-vp-article-body]
             > Title, Content, Author...

     NACHHER:
       .article__wrapper.vp-has-toc
         > .vp-article-body-grid              ← NEU (Grid-Container)
             > .vp-blog-toc                   ← NEU (TOC, links)
             > .v-stack[data-vp-article-body] ← VERSCHOBEN (rechts)
                 > Title, Content, Author... */

  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function escapeHtml(s) {
    return s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildTocAndLayout() {
    var wrapper = document.querySelector('.article__wrapper');
    var bodyContainer = document.querySelector('[data-vp-article-body]');
    if (!wrapper || !bodyContainer) return null;

    var prose = bodyContainer.querySelector('.prose');
    if (!prose) return null;

    var headings = prose.querySelectorAll('h2');
    if (headings.length < 2) {
      // Weniger als 2 Hauptabschnitte → kein TOC sinnvoll
      return null;
    }

    // IDs vergeben
    var usedIds = {};
    var entries = [];
    headings.forEach(function (h2) {
      var id = h2.id;
      if (!id) {
        var base = slugify(h2.textContent) || 'abschnitt';
        id = base;
        var i = 2;
        while (usedIds[id] || document.getElementById(id)) {
          id = base + '-' + i;
          i++;
        }
        h2.id = id;
      }
      usedIds[id] = true;
      entries.push({ id: id, text: h2.textContent });
    });

    // TOC-Element bauen
    var toc = document.createElement('aside');
    toc.className = 'vp-blog-toc vp-blog-toc--ready';
    toc.setAttribute('aria-label', 'Inhaltsverzeichnis');

    var html = '';
    html += '<button type="button" class="vp-blog-toc__mobile-toggle" aria-expanded="false" aria-controls="vp-blog-toc-list">';
    html += 'Inhaltsverzeichnis';
    html += '</button>';
    html += '<p class="vp-blog-toc__heading">In diesem Artikel</p>';
    html += '<ul class="vp-blog-toc__list" id="vp-blog-toc-list">';
    entries.forEach(function (e) {
      html += '<li class="vp-blog-toc__item">';
      html += '<a class="vp-blog-toc__link" href="#' + e.id + '" data-toc-target="' + e.id + '">';
      html += escapeHtml(e.text);
      html += '</a></li>';
    });
    html += '</ul>';
    toc.innerHTML = html;

    // Grid-Container bauen und Body hineinverlagern
    var grid = document.createElement('div');
    grid.className = 'vp-article-body-grid';

    // bodyContainer aus wrapper rausnehmen, in Grid hineinpacken
    // (TOC + bodyContainer im Grid, dann Grid an Stelle des bodyContainer)
    var parent = bodyContainer.parentNode;
    parent.insertBefore(grid, bodyContainer);
    grid.appendChild(toc);
    grid.appendChild(bodyContainer);

    wrapper.classList.add('vp-has-toc');

    return { container: toc, entries: entries };
  }

  /* ------------------------------------------------------------
     3. MOBILE-TOC-TOGGLE
     ------------------------------------------------------------ */

  function setupMobileToggle(tocContainer) {
    if (!tocContainer) return;
    var toggle = tocContainer.querySelector('.vp-blog-toc__mobile-toggle');
    if (!toggle) return;

    toggle.addEventListener('click', function () {
      var isOpen = tocContainer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    tocContainer.querySelectorAll('.vp-blog-toc__link').forEach(function (link) {
      link.addEventListener('click', function () {
        if (window.matchMedia('(max-width: 1099px)').matches) {
          tocContainer.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ------------------------------------------------------------
     4. SCROLLSPY
     ------------------------------------------------------------ */

  function setupScrollspy(tocData) {
    if (!tocData || !tocData.entries.length) return;

    var links = {};
    tocData.entries.forEach(function (e) {
      var link = tocData.container.querySelector('[data-toc-target="' + e.id + '"]');
      if (link) links[e.id] = link;
    });

    var headings = tocData.entries
      .map(function (e) {
        return document.getElementById(e.id);
      })
      .filter(Boolean);

    if (!headings.length) return;

    var observer = new IntersectionObserver(
      function (intersections) {
        intersections.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            Object.keys(links).forEach(function (key) {
              links[key].classList.toggle('is-active', key === id);
            });
          }
        });
      },
      {
        rootMargin: '-100px 0px -70% 0px',
        threshold: 0
      }
    );

    headings.forEach(function (h) {
      observer.observe(h);
    });
  }

  /* ------------------------------------------------------------
     INIT
     ------------------------------------------------------------ */

  function init() {
    enhanceFaqBlocks();
    var tocData = buildTocAndLayout();
    if (tocData) {
      setupMobileToggle(tocData.container);
      setupScrollspy(tocData);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();